module.exports = __webpack_public_path__ + "img/hyzxy.47fa44bf.png";